"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _customerOrderApi = require("@/api/customerOrderApi");
var _sortablejs = _interopRequireDefault(require("sortablejs"));
var _luckyWheelApi = require("@/api/luckyWheelApi");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i.return) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; } //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
// import JumpNative from '@/components/JumpNative';
var PRIZE_TYPE = {
  REDUCE: 1,
  DISCOUNT: 2,
  POINTS: 3,
  GOODS: 4,
  THANKS: 5,
  AGAIN: 6
};
var prizeRowSequence = 0;
var createPrize = function createPrize() {
  var prizeType = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;
  var probability = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 20;
  return {
    _rowKey: "prize-".concat(++prizeRowSequence),
    id: null,
    prizeType: prizeType,
    icon: '',
    couponId: null,
    couponOptions: [],
    couponLoading: false,
    points: '',
    skuId: null,
    skuOptions: [],
    skuLoading: false,
    displayText: '',
    bgColor: '#BBBBBB',
    probability: probability,
    productLimit: '',
    stock: '',
    _errors: {}
  };
};
var defaultFormData = function defaultFormData() {
  return {
    id: '',
    activityName: '',
    applyCustomerType: 0,
    customerIds: [],
    startTime: '',
    endTime: '',
    // 暂时不用：参与条件 / 订单类型 / 链接名称 / 抽奖次数限制
    // participateType: 1,
    // orderTypes: [1],
    // buyJumpValue: '',
    // drawLimitType: 1,
    // drawLimitTotal: '2',
    // drawLimitDaily: '',
    prizes: [createPrize(PRIZE_TYPE.REDUCE, 20), createPrize(PRIZE_TYPE.DISCOUNT, 20), createPrize(PRIZE_TYPE.POINTS, 20), createPrize(PRIZE_TYPE.GOODS, 20), createPrize(PRIZE_TYPE.THANKS, 20), createPrize(PRIZE_TYPE.AGAIN, 0)]
  };
};
var pad2 = function pad2(n) {
  return "0".concat(n).slice(-2);
};
var formatHms = function formatHms(date) {
  return "".concat(pad2(date.getHours()), ":").concat(pad2(date.getMinutes()), ":").concat(pad2(date.getSeconds()));
};
var endOfToday = function endOfToday() {
  var d = new Date();
  d.setHours(23, 59, 59, 0);
  return d;
};
var isSameDay = function isSameDay(a, b) {
  return a instanceof Date && b instanceof Date && a.getFullYear() === b.getFullYear() && a.getMonth() === b.getMonth() && a.getDate() === b.getDate();
};
var _default = exports.default = {
  name: 'LuckyWheelOperate',
  // components: { JumpNative },
  data: function data() {
    return {
      mode: this.$route && this.$route.params && this.$route.params.mode || 'create',
      activityStatus: null,
      currentStep: 0,
      detailLoading: false,
      submitLoading: false,
      customerLoading: false,
      couponListLoading: false,
      reduceCouponOptions: [],
      discountCouponOptions: [],
      customerOptions: [],
      duplicateHint: false,
      formData: defaultFormData(),
      startTimeDefaultTime: formatHms(new Date()),
      startTimeDefaultValue: new Date(),
      endTimeDefaultValue: endOfToday(),
      startTimePrevValue: '',
      endTimePrevValue: '',
      _normalizingStartTime: false,
      _normalizingEndTime: false,
      timePickerOptions: {
        disabledDate: function disabledDate(time) {
          var today = new Date();
          today.setHours(0, 0, 0, 0);
          return time.getTime() < today.getTime();
        }
      },
      // 暂时不用
      // orderTypeOptions: [
      //   { label: '普通商品订单', value: 1 },
      //   { label: '虚拟商品订单', value: 2 },
      //   { label: '优惠券商品订单', value: 3 },
      // ],
      prizeTypeOptions: [{
        label: '满减券',
        value: 1
      }, {
        label: '满折券',
        value: 2
      }, {
        label: '积分',
        value: 3
      }, {
        label: '商品',
        value: 4
      }, {
        label: '谢谢惠顾',
        value: 5
      }, {
        label: '再来一次',
        value: PRIZE_TYPE.AGAIN
      }]
    };
  },
  computed: {
    isView: function isView() {
      return this.mode === 'view';
    },
    isEdit: function isEdit() {
      return this.mode === 'edit';
    },
    isNotStarted: function isNotStarted() {
      return Number(this.activityStatus) === 0;
    },
    lockCustomerAndTime: function lockCustomerAndTime() {
      return this.isView || this.isEdit && !this.isNotStarted;
    },
    formRules: function formRules() {
      var _this = this;
      if (this.isView) {
        return {
          activityName: [],
          applyCustomerType: [],
          customerIds: [],
          startTime: [],
          endTime: []
        };
      }
      return {
        activityName: [{
          required: true,
          message: '请输入！',
          trigger: 'blur'
        }],
        applyCustomerType: [{
          required: true,
          message: '请选择！',
          trigger: 'change'
        }],
        customerIds: [{
          validator: function validator(rule, value, callback) {
            if (Number(_this.formData.applyCustomerType) === 1 && (!value || !value.length)) {
              callback(new Error('请选择！'));
            } else {
              callback();
            }
          },
          trigger: 'change'
        }],
        startTime: [{
          required: true,
          validator: this.checkStartTime,
          trigger: 'change'
        }],
        endTime: [{
          required: true,
          validator: this.checkEndTime,
          trigger: 'change'
        }]
      };
    },
    savePerms: function savePerms() {
      return this.isEdit ? ['admin:activity:luckywheel:activity:update'] : ['admin:activity:luckywheel:activity:save'];
    },
    probabilityTotal: function probabilityTotal() {
      return (this.formData.prizes || []).reduce(function (sum, row) {
        return sum + (Number(row.probability) || 0);
      }, 0);
    }
  },
  watch: {
    currentStep: function currentStep() {
      if (this.currentStep === 1) this.initPrizeSorting();
    },
    isView: function isView() {
      this.initPrizeSorting();
    },
    '$route.params': {
      handler: function handler() {
        this.initPageState();
      },
      deep: true
    }
  },
  created: function created() {
    this.initPageState();
  },
  mounted: function mounted() {
    this.initPrizeSorting();
  },
  beforeDestroy: function beforeDestroy() {
    if (this._prizeSortable) this._prizeSortable.destroy();
  },
  methods: {
    initPrizeSorting: function initPrizeSorting() {
      var _this2 = this;
      this.$nextTick(function () {
        if (_this2._prizeSortable) {
          _this2._prizeSortable.destroy();
          _this2._prizeSortable = null;
        }
        if (_this2.isView || _this2._isDestroyed || !_this2.$refs.prizeTable) return;
        var body = _this2.$refs.prizeTable.$el.querySelector('.el-table__body-wrapper tbody');
        if (!body) return;
        _this2._prizeSortable = _sortablejs.default.create(body, {
          handle: '.prize-drag-handle',
          draggable: '.el-table__row',
          animation: 150,
          onEnd: _this2.onPrizeSortEnd
        });
      });
    },
    onPrizeSortEnd: function onPrizeSortEnd(_ref) {
      var _this3 = this;
      var item = _ref.item,
        oldIndex = _ref.oldIndex,
        newIndex = _ref.newIndex;
      if (!Number.isInteger(oldIndex) || !Number.isInteger(newIndex) || oldIndex === newIndex) return;
      // 先还原拖拽改动的 DOM，再让 Vue 按稳定行标识更新，避免输入框与奖项错位。
      var body = item && item.parentNode;
      if (body) {
        body.removeChild(item);
        body.insertBefore(item, body.children[oldIndex] || null);
      }
      if (this.isView) return;
      var prizes = this.formData.prizes.slice();
      if (oldIndex < 0 || newIndex < 0 || oldIndex >= prizes.length || newIndex >= prizes.length) return;
      var _prizes$splice = prizes.splice(oldIndex, 1),
        _prizes$splice2 = _slicedToArray(_prizes$splice, 1),
        prize = _prizes$splice2[0];
      prizes.splice(newIndex, 0, prize);
      this.formData.prizes = prizes;
      this.$nextTick(function () {
        if (_this3.$refs.prizeTable) _this3.$refs.prizeTable.doLayout();
      });
    },
    checkStartTime: function checkStartTime(rule, value, callback) {
      if (this.isView || this.mode !== 'create') return callback();
      if (!value) return callback(new Error('请选择！'));
      if (new Date(value.replace(/-/g, '/')).getTime() < Date.now()) {
        return callback(new Error('不能早于当前时间'));
      }
      callback();
    },
    checkEndTime: function checkEndTime(rule, value, callback) {
      if (this.isView || this.mode !== 'create') return callback();
      if (!value) return callback(new Error('请选择！'));
      var end = new Date(value.replace(/-/g, '/')).getTime();
      if (end < Date.now()) return callback(new Error('不能早于当前时间'));
      if (this.formData.startTime) {
        var start = new Date(this.formData.startTime.replace(/-/g, '/')).getTime();
        if (end <= start) return callback(new Error('结束时间须晚于开始时间'));
      }
      callback();
    },
    parseDateTimeValue: function parseDateTimeValue(val) {
      var m = /^(\d{4}-\d{2}-\d{2}) (\d{2}:\d{2}:\d{2})$/.exec(String(val || ''));
      if (!m) return null;
      return {
        datePart: m[1],
        timePart: m[2]
      };
    },
    syncPickerDateTime: function syncPickerDateTime(refName, val) {
      var picker = this.$refs[refName] && this.$refs[refName].picker;
      if (!picker || !val) return;
      var d = new Date(String(val).replace(/-/g, '/'));
      if (Number.isNaN(d.getTime())) return;
      picker.value = d;
      picker.date = d;
      picker.defaultTime = String(val).slice(11);
    },
    normalizeStartTime: function normalizeStartTime(val, oldVal) {
      var cur = this.parseDateTimeValue(val);
      if (!cur) return val;
      var old = this.parseDateTimeValue(oldVal);
      var dateChanged = !old || old.datePart !== cur.datePart;
      var pickedDay = new Date("".concat(cur.datePart.replace(/-/g, '/'), " 00:00:00"));
      var now = new Date();
      if (isSameDay(pickedDay, now)) {
        if (dateChanged && cur.timePart === '00:00:00') {
          return "".concat(cur.datePart, " ").concat(this.startTimeDefaultTime || formatHms(now));
        }
        return val;
      }
      if (dateChanged && cur.timePart !== '00:00:00') {
        return "".concat(cur.datePart, " 00:00:00");
      }
      return val;
    },
    normalizeEndTime: function normalizeEndTime(val, oldVal) {
      var cur = this.parseDateTimeValue(val);
      if (!cur) return val;
      var old = this.parseDateTimeValue(oldVal);
      var dateChanged = !old || old.datePart !== cur.datePart;
      if (dateChanged && cur.timePart !== '23:59:59') {
        return "".concat(cur.datePart, " 23:59:59");
      }
      return val;
    },
    refreshStartTimeDefault: function refreshStartTimeDefault() {
      var _this4 = this;
      var now = new Date();
      this.startTimeDefaultValue = now;
      this.startTimeDefaultTime = formatHms(now);
      this.$nextTick(function () {
        var picker = _this4.$refs.startTimePicker && _this4.$refs.startTimePicker.picker;
        if (!picker) return;
        picker.defaultTime = _this4.startTimeDefaultTime;
        picker.defaultValue = _this4.startTimeDefaultValue;
      });
    },
    refreshEndTimeDefault: function refreshEndTimeDefault() {
      var _this5 = this;
      this.endTimeDefaultValue = endOfToday();
      this.$nextTick(function () {
        var picker = _this5.$refs.endTimePicker && _this5.$refs.endTimePicker.picker;
        if (!picker) return;
        picker.defaultTime = '23:59:59';
        picker.defaultValue = _this5.endTimeDefaultValue;
      });
    },
    onStartTimeInput: function onStartTimeInput(val) {
      var _this6 = this;
      this.duplicateHint = false;
      if (this._normalizingStartTime) return;
      var next = this.normalizeStartTime(val, this.startTimePrevValue) || val;
      this.startTimePrevValue = next || '';
      if (next !== this.formData.startTime) {
        this._normalizingStartTime = true;
        this.formData.startTime = next;
        this.syncPickerDateTime('startTimePicker', next);
        this.$nextTick(function () {
          _this6._normalizingStartTime = false;
        });
      }
    },
    onEndTimeInput: function onEndTimeInput(val) {
      var _this7 = this;
      this.duplicateHint = false;
      if (this._normalizingEndTime) return;
      var next = this.normalizeEndTime(val, this.endTimePrevValue) || val;
      this.endTimePrevValue = next || '';
      if (next !== this.formData.endTime) {
        this._normalizingEndTime = true;
        this.formData.endTime = next;
        this.syncPickerDateTime('endTimePicker', next);
        this.$nextTick(function () {
          _this7._normalizingEndTime = false;
        });
      }
    },
    isCouponPrize: function isCouponPrize(type) {
      return Number(type) === PRIZE_TYPE.REDUCE || Number(type) === PRIZE_TYPE.DISCOUNT;
    },
    isThanksPrize: function isThanksPrize(type) {
      return Number(type) === PRIZE_TYPE.THANKS;
    },
    showStockFields: function showStockFields(type) {
      var n = Number(type);
      return n === PRIZE_TYPE.REDUCE || n === PRIZE_TYPE.DISCOUNT || n === PRIZE_TYPE.GOODS;
    },
    hasSelectedPrizeContent: function hasSelectedPrizeContent(row) {
      if (!row) return false;
      if (this.isCouponPrize(row.prizeType)) return row.couponId != null && row.couponId !== '';
      if (Number(row.prizeType) === PRIZE_TYPE.GOODS) return row.skuId != null && row.skuId !== '';
      return false;
    },
    hasStockValue: function hasStockValue(row) {
      return row && row.stock !== '' && row.stock != null;
    },
    canEditProductLimit: function canEditProductLimit(row) {
      return this.showStockFields(row.prizeType) && this.hasSelectedPrizeContent(row) && this.hasStockValue(row);
    },
    prizeFieldError: function prizeFieldError(row, key) {
      return row && row._errors && row._errors[key] || '';
    },
    clearPrizeError: function clearPrizeError(row, key) {
      if (!row || !row._errors || !row._errors[key]) return;
      this.$set(row._errors, key, '');
    },
    clearPrizeIcon: function clearPrizeIcon(row) {
      row.icon = '';
    },
    collectPrizeRowErrors: function collectPrizeRowErrors(row) {
      var errors = {};
      if (!row.prizeType) errors.prizeType = '请选择！';
      if (!(row.icon || '').trim()) errors.icon = '请选择！';
      if (this.isCouponPrize(row.prizeType) && !row.couponId) errors.content = '请选择！';
      if (Number(row.prizeType) === PRIZE_TYPE.POINTS && Number(row.points) < 1) errors.content = '请输入！';
      if (Number(row.prizeType) === PRIZE_TYPE.GOODS && !row.skuId) errors.content = '请输入！';
      if (this.showStockFields(row.prizeType) && (row.productLimit === '' || row.productLimit == null || Number(row.productLimit) < 1)) {
        errors.productLimit = '请输入！';
      }
      if (!(row.displayText || '').trim()) errors.displayText = '请输入！';
      var probability = Number(row.probability);
      var minProbability = this.isThanksPrize(row.prizeType) ? 1 : 0;
      if (row.probability === '' || row.probability == null) {
        errors.probability = '请输入！';
      } else if (!Number.isInteger(probability) || probability < minProbability || probability > 100) {
        errors.probability = "\u8BF7\u8F93\u5165".concat(minProbability, "-100\u7684\u6574\u6570");
      }
      return errors;
    },
    stockDisplay: function stockDisplay(row) {
      if (!this.showStockFields(row.prizeType) || !this.hasStockValue(row)) return '—';
      return row.stock;
    },
    pickStockFromItem: function pickStockFromItem(item) {
      if (!item) return '';
      var keys = ['stock', 'remain', 'remainNum', 'surplus', 'lastTotal', 'quantity', 'totalQuantity', 'skuStock'];
      for (var i = 0; i < keys.length; i += 1) {
        var val = item[keys[i]];
        if (val != null && val !== '') return String(val);
      }
      return '';
    },
    applySelectedStock: function applySelectedStock(row, item) {
      var stock = this.pickStockFromItem(item);
      this.$set(row, 'stock', stock);
      if (!stock) {
        this.$set(row, 'productLimit', '');
        return;
      }
      if (row.productLimit !== '' && row.productLimit != null && Number(row.productLimit) > Number(stock)) {
        this.$set(row, 'productLimit', String(stock));
      }
    },
    clearSelectedStock: function clearSelectedStock(row) {
      this.$set(row, 'stock', '');
      this.$set(row, 'productLimit', '');
    },
    skuOptionLabel: function skuOptionLabel(item) {
      if (!item) return '';
      var name = item.skuName || item.productName || item.name || '';
      return name ? "skuid: ".concat(item.skuId, " ").concat(name) : "skuid: ".concat(item.skuId);
    },
    normalizeCustomerItem: function normalizeCustomerItem(item) {
      if (!item) return null;
      var customerId = item.customerId != null ? Number(item.customerId) : Number(item.id);
      if (!Number.isInteger(customerId) || customerId <= 0) return null;
      return _objectSpread(_objectSpread({}, item), {}, {
        customerId: customerId,
        appName: item.appName || item.customerName || item.name || String(customerId)
      });
    },
    initPageState: function initPageState() {
      var _this8 = this;
      this.mode = this.$route.params.mode || 'create';
      var routeId = this.$route.params.id || '';
      this.currentStep = 0;
      this.duplicateHint = false;
      this.activityStatus = null;
      this.formData = defaultFormData();
      this.startTimePrevValue = '';
      this.endTimePrevValue = '';
      this.customerOptions = [];
      this.$nextTick(function () {
        if (_this8.$refs.baseForm) _this8.$refs.baseForm.clearValidate();
      });
      this.searchCustomerOptions('');
      this.loadCouponOptions();
      if (routeId) this.loadActivityDetail(routeId);
    },
    searchCustomerOptions: function () {
      var _searchCustomerOptions = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(keyword) {
        var _this9 = this;
        var res, next, byId;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.p = _context.n) {
            case 0:
              this.customerLoading = true;
              _context.p = 1;
              _context.n = 2;
              return (0, _customerOrderApi.companyappAutoListApi)({
                keyword: keyword || ''
              });
            case 2:
              res = _context.v;
              next = (Array.isArray(res) ? res : []).map(function (item) {
                return _this9.normalizeCustomerItem(item);
              }).filter(Boolean);
              byId = new Map(next.map(function (item) {
                return [Number(item.customerId), item];
              }));
              (this.formData.customerIds || []).forEach(function (id) {
                var exist = (_this9.customerOptions || []).find(function (x) {
                  return Number(x.customerId) === Number(id);
                });
                if (exist && !byId.has(Number(id))) byId.set(Number(id), exist);
              });
              this.customerOptions = Array.from(byId.values());
            case 3:
              _context.p = 3;
              this.customerLoading = false;
              return _context.f(3);
            case 4:
              return _context.a(2);
          }
        }, _callee, this, [[1,, 3, 4]]);
      }));
      function searchCustomerOptions(_x) {
        return _searchCustomerOptions.apply(this, arguments);
      }
      return searchCustomerOptions;
    }(),
    couponOptionsFor: function couponOptionsFor(row) {
      var type = Number(row && row.prizeType);
      var list = [];
      if (type === PRIZE_TYPE.REDUCE) list = this.reduceCouponOptions || [];
      if (type === PRIZE_TYPE.DISCOUNT) list = this.discountCouponOptions || [];
      if (row && row.couponId != null && row.couponId !== '') {
        var exists = list.some(function (item) {
          return String(item.id) === String(row.couponId);
        });
        if (!exists) {
          var extra = (row.couponOptions || []).find(function (item) {
            return String(item.id) === String(row.couponId);
          });
          if (extra) return [extra].concat(list);
        }
      }
      return list;
    },
    loadCouponOptions: function () {
      var _loadCouponOptions = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2() {
        var _yield$Promise$all, _yield$Promise$all2, reduce, discount, _t;
        return _regenerator().w(function (_context2) {
          while (1) switch (_context2.p = _context2.n) {
            case 0:
              this.couponListLoading = true;
              _context2.p = 1;
              _context2.n = 2;
              return Promise.all([(0, _luckyWheelApi.luckyWheelCouponListApi)({
                couponType: 1
              }), (0, _luckyWheelApi.luckyWheelCouponListApi)({
                couponType: 2
              })]);
            case 2:
              _yield$Promise$all = _context2.v;
              _yield$Promise$all2 = _slicedToArray(_yield$Promise$all, 2);
              reduce = _yield$Promise$all2[0];
              discount = _yield$Promise$all2[1];
              this.reduceCouponOptions = Array.isArray(reduce) ? reduce : [];
              this.discountCouponOptions = Array.isArray(discount) ? discount : [];
              _context2.n = 4;
              break;
            case 3:
              _context2.p = 3;
              _t = _context2.v;
              this.reduceCouponOptions = [];
              this.discountCouponOptions = [];
            case 4:
              _context2.p = 4;
              this.couponListLoading = false;
              return _context2.f(4);
            case 5:
              return _context2.a(2);
          }
        }, _callee2, this, [[1, 3, 4, 5]]);
      }));
      function loadCouponOptions() {
        return _loadCouponOptions.apply(this, arguments);
      }
      return loadCouponOptions;
    }(),
    onCouponChange: function onCouponChange(row) {
      this.clearPrizeError(row, 'content');
      if (!row.couponId) {
        this.clearSelectedStock(row);
        return;
      }
      var item = this.couponOptionsFor(row).find(function (x) {
        return String(x.id) === String(row.couponId);
      });
      this.applySelectedStock(row, item);
    },
    mapSkuInfo: function mapSkuInfo(info, fallbackId) {
      if (!info) return null;
      return {
        skuId: info.skuId != null ? info.skuId : fallbackId,
        skuName: info.productName || '',
        productName: info.productName || '',
        stock: info.stock
      };
    },
    searchSkuOptions: function () {
      var _searchSkuOptions = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3(row, keyword) {
        var _this0 = this;
        var skuId, exist;
        return _regenerator().w(function (_context3) {
          while (1) switch (_context3.n) {
            case 0:
              skuId = String(keyword || '').trim();
              if (row._skuSearchTimer) clearTimeout(row._skuSearchTimer);
              if (/^\d+$/.test(skuId)) {
                _context3.n = 1;
                break;
              }
              return _context3.a(2);
            case 1:
              exist = (row.skuOptions || []).find(function (item) {
                return String(item.skuId) === skuId;
              });
              if (!exist) {
                _context3.n = 2;
                break;
              }
              return _context3.a(2);
            case 2:
              row._skuSearchTimer = setTimeout(function () {
                _this0.fetchSkuOptions(row, skuId);
              }, 400);
            case 3:
              return _context3.a(2);
          }
        }, _callee3);
      }));
      function searchSkuOptions(_x2, _x3) {
        return _searchSkuOptions.apply(this, arguments);
      }
      return searchSkuOptions;
    }(),
    fetchSkuOptions: function () {
      var _fetchSkuOptions = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee4(row, skuId) {
        var info, option, _t2;
        return _regenerator().w(function (_context4) {
          while (1) switch (_context4.p = _context4.n) {
            case 0:
              this.$set(row, 'skuLoading', true);
              _context4.p = 1;
              _context4.n = 2;
              return (0, _luckyWheelApi.luckyWheelSkuInfoApi)(Number(skuId), {
                silent: true
              });
            case 2:
              info = _context4.v;
              option = this.mapSkuInfo(info, Number(skuId));
              this.$set(row, 'skuOptions', option ? [option] : []);
              _context4.n = 4;
              break;
            case 3:
              _context4.p = 3;
              _t2 = _context4.v;
              this.$set(row, 'skuOptions', []);
            case 4:
              _context4.p = 4;
              this.$set(row, 'skuLoading', false);
              return _context4.f(4);
            case 5:
              return _context4.a(2);
          }
        }, _callee4, this, [[1, 3, 4, 5]]);
      }));
      function fetchSkuOptions(_x4, _x5) {
        return _fetchSkuOptions.apply(this, arguments);
      }
      return fetchSkuOptions;
    }(),
    onSkuChange: function () {
      var _onSkuChange = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee5(row) {
        var exist, info, option, _t3;
        return _regenerator().w(function (_context5) {
          while (1) switch (_context5.p = _context5.n) {
            case 0:
              this.clearPrizeError(row, 'content');
              if (row.skuId) {
                _context5.n = 1;
                break;
              }
              this.clearSelectedStock(row);
              return _context5.a(2);
            case 1:
              exist = (row.skuOptions || []).find(function (x) {
                return String(x.skuId) === String(row.skuId);
              });
              if (!(exist && this.hasStockValue(exist))) {
                _context5.n = 2;
                break;
              }
              this.applySelectedStock(row, exist);
              return _context5.a(2);
            case 2:
              this.$set(row, 'skuLoading', true);
              _context5.p = 3;
              _context5.n = 4;
              return (0, _luckyWheelApi.luckyWheelSkuInfoApi)(row.skuId, {
                silent: true
              });
            case 4:
              info = _context5.v;
              option = this.mapSkuInfo(info, row.skuId);
              if (option) {
                this.$set(row, 'skuOptions', [option]);
                this.applySelectedStock(row, option);
              }
              _context5.n = 6;
              break;
            case 5:
              _context5.p = 5;
              _t3 = _context5.v;
              this.clearSelectedStock(row);
            case 6:
              _context5.p = 6;
              this.$set(row, 'skuLoading', false);
              return _context5.f(6);
            case 7:
              return _context5.a(2);
          }
        }, _callee5, this, [[3, 5, 6, 7]]);
      }));
      function onSkuChange(_x6) {
        return _onSkuChange.apply(this, arguments);
      }
      return onSkuChange;
    }(),
    onPrizeTypeChange: function onPrizeTypeChange(row) {
      this.clearPrizeError(row, 'prizeType');
      this.onProbabilityInput(row, row.probability);
      this.clearPrizeError(row, 'content');
      this.clearPrizeError(row, 'productLimit');
      row.couponId = null;
      row.couponOptions = [];
      row.points = '';
      row.skuId = null;
      row.skuOptions = [];
      row.productLimit = '';
      row.stock = '';
    },
    onProductLimitInput: function onProductLimitInput(row, value) {
      var digits = String(value || '').replace(/[^\d]/g, '');
      if (digits === '') {
        row.productLimit = '';
        return;
      }
      var n = Number(digits);
      if (n < 1) {
        row.productLimit = '';
        return;
      }
      var stock = Number(row.stock);
      if (this.hasStockValue(row) && Number.isFinite(stock) && n > stock) n = stock;
      row.productLimit = String(n);
      this.clearPrizeError(row, 'productLimit');
    },
    // 暂时不用：抽奖次数限制
    // onDigitsInput(field, value) {
    //   this.formData[field] = String(value || '').replace(/[^\d]/g, '').slice(0, 5);
    // },
    onPointsInput: function onPointsInput(row, value) {
      var digits = String(value || '').replace(/[^\d]/g, '');
      if (digits === '') {
        row.points = '';
        return;
      }
      var n = Number(digits);
      row.points = n < 1 ? '' : String(n);
      this.clearPrizeError(row, 'content');
    },
    onProbabilityInput: function onProbabilityInput(row, value) {
      var num = String(value == null ? '' : value).replace(/[^\d]/g, '');
      if (num === '') {
        row.probability = '';
        return;
      }
      var n = Number(num);
      var minProbability = this.isThanksPrize(row.prizeType) ? 1 : 0;
      if (n < minProbability) n = minProbability;
      if (n > 100) n = 100;
      row.probability = String(n);
      this.clearPrizeError(row, 'probability');
    },
    uploadPrizeIcon: function uploadPrizeIcon(index) {
      var _this1 = this;
      if (this.isView) return;
      this.$modalUpload(function (img) {
        if (!img || !img[0]) return;
        _this1.$set(_this1.formData.prizes[index], 'icon', img[0].sattDir || img[0].attDir || img[0].url || '');
        _this1.clearPrizeError(_this1.formData.prizes[index], 'icon');
      }, '1', 'system', false, {
        maxSizeKB: 200,
        maxSizeErrorMsg: '图标大小需小于等于 200KB！'
      });
    },
    addPrize: function addPrize() {
      if (this.formData.prizes.length >= 10) {
        this.$message.warning('奖项数量上限为10');
        return;
      }
      this.formData.prizes.push(createPrize(PRIZE_TYPE.REDUCE, ''));
    },
    removePrize: function removePrize(index) {
      var row = this.formData.prizes[index];
      if (!row || this.isThanksPrize(row.prizeType)) return;
      this.formData.prizes.splice(index, 1);
    },
    hasFormData: function hasFormData() {
      var fd = this.formData;
      if ((fd.activityName || '').trim()) return true;
      if (Number(fd.applyCustomerType) === 1 && (fd.customerIds || []).length) return true;
      if (fd.startTime || fd.endTime) return true;
      // if (fd.buyJumpValue) return true;
      // if ((fd.orderTypes || []).join(',') !== '1') return true;
      return (fd.prizes || []).some(function (row) {
        if (row.icon) return true;
        if (row.couponId) return true;
        if (row.skuId) return true;
        if (row.points) return true;
        if (row.displayText) return true;
        if (row.productLimit) return true;
        return false;
      });
    },
    prevStep: function prevStep() {
      this.currentStep = 0;
    },
    onApplyCustomerTypeChange: function onApplyCustomerTypeChange(val) {
      var _this10 = this;
      this.duplicateHint = false;
      if (Number(val) === 0) {
        this.formData.customerIds = [];
        this.$nextTick(function () {
          if (_this10.$refs.baseForm) _this10.$refs.baseForm.clearValidate('customerIds');
        });
      } else {
        this.searchCustomerOptions('');
      }
    },
    onCustomerSelectVisible: function onCustomerSelectVisible(visible) {
      if (visible) this.searchCustomerOptions('');
    },
    // 暂时不用：链接名称
    // onJumpChange() {
    //   if (this.$refs.baseForm) this.$refs.baseForm.validateField('buyJumpValue');
    // },
    nextStep: function nextStep() {
      var _this11 = this;
      if (this.isView) {
        this.currentStep = 1;
        return;
      }
      var fields = ['activityName', 'applyCustomerType', 'customerIds', 'startTime', 'endTime'];
      var pending = fields.length;
      var failed = false;
      fields.forEach(function (field) {
        _this11.$refs.baseForm.validateField(field, function (err) {
          if (err) failed = true;
          pending -= 1;
          if (pending === 0 && !failed) _this11.currentStep = 1;
        });
      });
    },
    handleCancel: function handleCancel() {
      var _this12 = this;
      var back = function back() {
        return _this12.$router.push({
          path: '/marketing/luckyWheel/list'
        });
      };
      if (!this.hasFormData() || this.isView) {
        back();
        return;
      }
      this.$confirm('存在数据，点击【取消】全部数据不保留，确认取消？', '提示', {
        confirmButtonText: '确认',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(back).catch(function () {});
    },
    validatePrizes: function validatePrizes() {
      var _this13 = this;
      var prizes = this.formData.prizes || [];
      if (!prizes.length) {
        this.$message.error('请配置奖项');
        return false;
      }
      var ok = true;
      prizes.forEach(function (row) {
        var errors = _this13.collectPrizeRowErrors(row);
        _this13.$set(row, '_errors', errors);
        if (Object.keys(errors).length) ok = false;
      });
      if (this.probabilityTotal !== 100) {
        this.$message.error('奖项配置的中奖概率总和不为100%，请重新配置～');
        ok = false;
      }
      if (!ok) {
        this.$nextTick(function () {
          if (_this13.$refs.prizeTable) _this13.$refs.prizeTable.doLayout();
          var el = _this13.$el.querySelector('.cell-field.is-invalid, .icon-upload.is-invalid, .icon-preview.is-invalid');
          if (el && el.scrollIntoView) el.scrollIntoView({
            block: 'center'
          });
        });
      }
      return ok;
    },
    isDuplicateError: function isDuplicateError(error) {
      var text = String(error && (error.message || error.msg) || '');
      return /已有活动重复/.test(text);
    },
    applyDuplicateHint: function applyDuplicateHint() {
      this.duplicateHint = true;
      this.currentStep = 0;
    },
    buildSubmitBody: function buildSubmitBody() {
      var _this14 = this;
      var fd = this.formData;
      return {
        id: this.isEdit ? fd.id : undefined,
        activityName: (fd.activityName || '').trim(),
        applyCustomerType: Number(fd.applyCustomerType) === 0 ? 0 : 1,
        applyCustomerIds: Number(fd.applyCustomerType) === 1 ? fd.customerIds || [] : [],
        startTime: fd.startTime,
        endTime: fd.endTime,
        // 暂时不用
        // participateType: fd.participateType,
        // orderTypes: fd.orderTypes || [],
        // buyJumpValue: fd.buyJumpValue,
        // drawLimitType: fd.drawLimitType,
        // drawLimitCount: Number(fd.drawLimitType === 1 ? fd.drawLimitTotal : fd.drawLimitDaily),
        prizes: (fd.prizes || []).map(function (row, index) {
          return {
            id: row.id || undefined,
            slotNo: index + 1,
            prizeType: Number(row.prizeType),
            icon: row.icon || '',
            couponId: _this14.isCouponPrize(row.prizeType) ? row.couponId : undefined,
            integralValue: Number(row.prizeType) === PRIZE_TYPE.POINTS ? Number(row.points) : undefined,
            skuId: Number(row.prizeType) === PRIZE_TYPE.GOODS ? row.skuId : undefined,
            displayText: (row.displayText || '').trim(),
            backgroundColor: row.bgColor,
            winProbability: Number(row.probability),
            issueLimit: _this14.showStockFields(row.prizeType) ? Number(row.productLimit) : undefined
          };
        })
      };
    },
    applyActivityDetailToForm: function applyActivityDetailToForm(data) {
      if (!data) return;
      var customerIds = Array.isArray(data.applyCustomerIds) ? data.applyCustomerIds.map(function (x) {
        return Number(x);
      }).filter(function (x) {
        return !Number.isNaN(x);
      }) : [];
      var applyCustomerType = 0;
      if (data.applyCustomerType != null && data.applyCustomerType !== '') {
        applyCustomerType = Number(data.applyCustomerType) === 0 ? 0 : 1;
      } else if (customerIds.length) {
        applyCustomerType = 1;
      }
      var prizes = Array.isArray(data.prizes) && data.prizes.length ? data.prizes.map(function (row) {
        var prize = createPrize(Number(row.prizeType) || 1, row.winProbability != null ? row.winProbability : row.probability);
        prize.id = row.id || null;
        prize.icon = row.icon || '';
        prize.couponId = row.couponId || null;
        prize.points = row.integralValue != null ? String(row.integralValue) : row.points != null ? String(row.points) : '';
        prize.skuId = row.skuId || null;
        prize.displayText = row.displayText || '';
        prize.bgColor = row.backgroundColor || row.bgColor || '#BBBBBB';
        prize.probability = row.winProbability != null ? String(row.winProbability) : row.probability != null ? String(row.probability) : '';
        prize.productLimit = row.issueLimit != null ? String(row.issueLimit) : row.productLimit != null ? String(row.productLimit) : '';
        prize.stock = row.stock != null ? String(row.stock) : '';
        if (prize.couponId) {
          prize.couponOptions = [{
            id: prize.couponId,
            name: row.couponName || String(prize.couponId),
            stock: row.stock
          }];
        }
        if (prize.skuId) {
          prize.skuOptions = [{
            skuId: prize.skuId,
            skuName: row.skuName || row.productName || '',
            defaultPrice: row.skuPrice,
            stock: row.stock
          }];
        }
        return prize;
      }) : defaultFormData().prizes;
      this.formData = _objectSpread(_objectSpread({}, defaultFormData()), {}, {
        id: data.id || '',
        activityName: data.activityName || '',
        applyCustomerType: applyCustomerType,
        customerIds: customerIds,
        startTime: data.startTime || '',
        endTime: data.endTime || '',
        // 暂时不用
        // participateType: data.participateType != null ? Number(data.participateType) : 1,
        // orderTypes: Array.isArray(data.orderTypes) && data.orderTypes.length ? data.orderTypes.map(Number) : [1],
        // buyJumpValue: data.buyJumpValue || data.jumpValue || '',
        // drawLimitType: data.drawLimitType != null ? Number(data.drawLimitType) : 1,
        // drawLimitTotal: Number(data.drawLimitType) === 2 ? '' : String(data.drawLimitCount != null ? data.drawLimitCount : 2),
        // drawLimitDaily: Number(data.drawLimitType) === 2 ? String(data.drawLimitCount || '') : '',
        prizes: prizes
      });
      this.startTimePrevValue = this.formData.startTime || '';
      this.endTimePrevValue = this.formData.endTime || '';
      this.activityStatus = data.status != null && data.status !== '' ? Number(data.status) : null;
      if (this.mode === 'edit' && (this.activityStatus === 1 || this.activityStatus === 2)) {
        this.mode = 'view';
      }
    },
    loadActivityDetail: function () {
      var _loadActivityDetail = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee6(routeId) {
        var _this15 = this;
        var data, _t4;
        return _regenerator().w(function (_context6) {
          while (1) switch (_context6.p = _context6.n) {
            case 0:
              this.detailLoading = true;
              _context6.p = 1;
              if (!(this.mode === 'copy')) {
                _context6.n = 3;
                break;
              }
              _context6.n = 2;
              return (0, _luckyWheelApi.luckyWheelCopyInfoApi)(routeId);
            case 2:
              _t4 = _context6.v;
              _context6.n = 5;
              break;
            case 3:
              _context6.n = 4;
              return (0, _luckyWheelApi.luckyWheelInfoApi)(routeId);
            case 4:
              _t4 = _context6.v;
            case 5:
              data = _t4;
              this.applyActivityDetailToForm(data);
              if (this.mode === 'copy') {
                this.formData.id = '';
                this.formData.activityName = '';
                this.formData.applyCustomerType = 0;
                this.formData.customerIds = [];
              }
              this.$nextTick(function () {
                if (_this15.$refs.baseForm) _this15.$refs.baseForm.clearValidate();
              });
            case 6:
              _context6.p = 6;
              this.detailLoading = false;
              return _context6.f(6);
            case 7:
              return _context6.a(2);
          }
        }, _callee6, this, [[1,, 6, 7]]);
      }));
      function loadActivityDetail(_x7) {
        return _loadActivityDetail.apply(this, arguments);
      }
      return loadActivityDetail;
    }(),
    handleSave: function () {
      var _handleSave = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee7() {
        var _this16 = this;
        var step1, body, _t5;
        return _regenerator().w(function (_context7) {
          while (1) switch (_context7.p = _context7.n) {
            case 0:
              if (!this.isView) {
                _context7.n = 1;
                break;
              }
              return _context7.a(2);
            case 1:
              _context7.n = 2;
              return new Promise(function (resolve) {
                return _this16.$refs.baseForm.validate(function (valid) {
                  return resolve(valid);
                });
              });
            case 2:
              step1 = _context7.v;
              if (step1) {
                _context7.n = 3;
                break;
              }
              this.currentStep = 0;
              return _context7.a(2);
            case 3:
              if (this.validatePrizes()) {
                _context7.n = 4;
                break;
              }
              return _context7.a(2);
            case 4:
              body = this.buildSubmitBody();
              this.submitLoading = true;
              _context7.p = 5;
              if (!this.isEdit) {
                _context7.n = 7;
                break;
              }
              _context7.n = 6;
              return (0, _luckyWheelApi.luckyWheelUpdateApi)(body);
            case 6:
              this.$message.success('保存成功');
              _context7.n = 9;
              break;
            case 7:
              _context7.n = 8;
              return (0, _luckyWheelApi.luckyWheelSaveApi)(body);
            case 8:
              this.$message.success('添加成功');
            case 9:
              this.$closeCompletedView();
              this.$router.push({
                path: '/marketing/luckyWheel/list'
              });
              _context7.n = 11;
              break;
            case 10:
              _context7.p = 10;
              _t5 = _context7.v;
              if (this.isDuplicateError(_t5)) this.applyDuplicateHint();
            case 11:
              _context7.p = 11;
              this.submitLoading = false;
              return _context7.f(11);
            case 12:
              return _context7.a(2);
          }
        }, _callee7, this, [[5, 10, 11, 12]]);
      }));
      function handleSave() {
        return _handleSave.apply(this, arguments);
      }
      return handleSave;
    }()
  }
};